import { Text } from "@/modules/hotels/interfaces/hotelDetailsResponse";
import { HotelText } from "@/modules/hotels/interfaces/hotelText";

export const useHotelTexts = () => {
  const getHotelTexts = (textsArray: Text[]) => {
    const hotelTexts = [] as HotelText[];

    textsArray.forEach((text) => {
      let title, description, icon;

      if (text.additionalDetailCode == "2" && text.infoCode == "1") {
        title = "Descripcion del hotel";
        icon = "library_books";
      } else if (text.additionalDetailCode == "10" && text.infoCode == "1") {
        title = "Impuestos";
        icon = "paid";
      } else if (text.additionalDetailCode == "24") {
        title = "Informacion extra";
        icon = "info";
      } else if (text.additionalDetailCode == "23") {
        title = "Informacion de la instalacion";
        icon = "apartment";
      } else if (text.additionalDetailCode == "34") {
        title = "Seguridad";
        icon = "security";
      } else if (text.infoCode == "5") {
        title = "Other";
        icon = "more_horiz";
      }

      if (title) {
        description =
          text.description.charAt(0).toUpperCase() +
          text.description.slice(1).toLowerCase();

        hotelTexts.push({
          title,
          description,
          icon,
        });
      }
    });

    return {
      hotelTexts,
    };
  };

  return {
    getHotelTexts,
  };
};
